import { UsersApi, UserResponse, QuickLinkResponse } from 'cmp-client-api';
import { UserServiceInterface } from './types/user.service.interface';

export class UserService implements UserServiceInterface {
  private readonly service: UsersApi;

  public constructor(service: UsersApi) {
    this.service = service;
  }

  public async getUser(): Promise<UserResponse> {
    return this.service.getUser().then(({ data }) => data);
  }

  public async getUserQuickLinks(): Promise<QuickLinkResponse[]> {
    return this.service.getUserQuickLinks().then(({ data }) => data);
  }

  public async endUserIdentityAssumption(userId: string): Promise<void> {
    return this.service.endUserIdentityAssumption(userId).then(({ data }) => data);
  }
}
